import { useState, useEffect } from 'react';
import { setGlobalLogoutCallback } from '../config/api';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Verificar se há token no localStorage ao carregar a aplicação
    checkAuthStatus();
    
    // Configurar callback global para logout automático
    setGlobalLogoutCallback(autoLogout);
    
    // Cleanup: remover callback quando componente for desmontado
    return () => {
      setGlobalLogoutCallback(null);
    };
  }, []);

  const checkAuthStatus = () => {
    const token = localStorage.getItem('authToken');
    const storedUserInfo = localStorage.getItem('userInfo');
    
    if (token) {
      setIsAuthenticated(true);
      if (storedUserInfo) {
        try {
          setUserInfo(JSON.parse(storedUserInfo));
        } catch (error) {
          console.error('Erro ao parsear informações do usuário:', error);
        }
      }
    } else {
      setIsAuthenticated(false);
      setUserInfo(null);
    }
    
    setLoading(false);
  };

  const login = (token, user = null) => {
    localStorage.setItem('authToken', token);
    if (user) {
      localStorage.setItem('userInfo', JSON.stringify(user));
      setUserInfo(user);
    }
    setIsAuthenticated(true);
  };

  const isAdmin = () => {
    const isAdminUser = userInfo?.isAdmin;
    return isAdminUser;
  };

  const logout = (redirectToLogin = false) => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('userInfo');
    setIsAuthenticated(false);
    setUserInfo(null);
    
    // Se for logout automático por 403, redirecionar para login
    if (redirectToLogin) {
      // Usar window.location para garantir redirecionamento mesmo em componentes não montados
      window.location.href = '/login';
    }
  };

  // Função para logout automático (chamada pela API em caso de 403)
  const autoLogout = () => {
    console.log('Executando logout automático devido a token inválido...');
    logout(true);
  };

  const getToken = () => {
    return localStorage.getItem('authToken');
  };
  const getUserInfo = () => {
    return JSON.parse(localStorage.getItem('userInfo'));
  };

  return {
    isAuthenticated,
    userInfo,
    loading,
    login,
    logout,
    autoLogout,
    getToken,
    getUserInfo,
    checkAuthStatus,
    isAdmin
  };
};
